import { For, Show } from "solid-js";
import * as styles from "./css/FiringModeManager.module.css";
import { playerState } from "@stores";
import { FiringMode } from "./mode";
const FiringModeManager = () => {
    return (<Show when={playerState() && playerState()?.gun}>
            <ul class={styles.firing_types}>
                <For each={playerState().gun.allowedFiringModes}>
                    {firingMode => (<FiringMode title={firingMode} selected={playerState().gun.firingMode === firingMode}/>)}
                </For>
            </ul>
        </Show>);
};
export default FiringModeManager;
